// Pages
import Aircrafts from "./pages/Dashboard/Aircraft/Aircrafts";
import Flights from "./pages/Dashboard/Flights/Flights";
import ViewFlight from "./pages/Dashboard/Flights/viewFlight";
import Home from "./pages/Dashboard/Home";
import Achievement from "./pages/Dashboard/Training/Achievement";
import Endorsement from "./pages/Dashboard/Training/Endorsement";
import Instructor from "./pages/Dashboard/Training/Instructor";
import Ratings from "./pages/Dashboard/Training/Ratings";
import RequestSignature from "./pages/Dashboard/Training/RequestSignature";
import Students from "./pages/Dashboard/Training/Students";

// Images
import search from "./assets/images/Search.svg";
import fligths from "./assets/images/Flights.svg";
import aircraft from "./assets/images/Aircraft.svg";
import airport from "./assets/images/Airport.svg";
import total from "./assets/images/Total.svg";
import imports from "./assets/images/Import.svg";
import CreateEndorsement from "./pages/Dashboard/Training/Endorsement/CreateEndorsement";
import CreateRequestSignature from "./pages/Dashboard/Training/RequestSignature/CreateRequestSignature";
import Report from "./pages/Dashboard/Reports/Report";
import Backup from "./pages/Dashboard/Backup/Backup";
import ViewEndorsement from "./pages/Dashboard/Training/Endorsement/ViewEndorsement";
import Invitations from "./pages/Dashboard/Training/Invitations";
import ApproveRequestPage from "./pages/Dashboard/Training/RequestSignature/ApproveRequestPage";
import Import from "./pages/Dashboard/Import/Import";
import Airport from "./pages/Dashboard/Airport/Airport";
import AdminDashboard from "./pages/Admin/Home";
import Users from "./pages/Admin/Users";
import UserGroupForm from "./pages/Admin/UserGroups/UserGroupForm";
import UserGroupList from "./pages/Admin/UserGroups/UserGroupList";
import AdminFlights from "./pages/Admin/Flights";
import InviteUsers from "./pages/Admin/Users/InviteUsers";
import EditUser from "./pages/Admin/Users/EditUsers";
import EditGroup from "./pages/Admin/UserGroups/EditGroup";
import UserStats from "./pages/Admin/Users/UserStats";

export const TrainingRuotes = [
  {
    lable: "Endorsement",
    path: "/training/endorsement",
    element: <Endorsement />,
    icon: "icon",
  },
  {
    lable: "Create Endorsement",
    path: "/training/endorsement/create",
    element: <CreateEndorsement />,
    icon: "icon",
    children: true,
  },
  {
    lable: "View Endorsement",
    path: "/training/endorsement/view/:id",
    element: <ViewEndorsement />,
    icon: "icon",
    children: true,
  },
  {
    lable: "Instructors",
    path: "/training/instructors",
    element: <Instructor />,
    icon: "icon",
  },
  {
    lable: "Students",
    path: "/training/students",
    element: <Students />,
    icon: "icon",
  },
  {
    lable: "Invitations",
    path: "/training/invitations",
    element: <Invitations />,
    icon: "icon",
    children: true,
  },
  {
    lable: "Request Signatures",
    path: "/training/request-signatures",
    element: <RequestSignature />,
    icon: "icon",
  },
  {
    lable: "Request Signatures",
    path: "/training/request-signatures/create",
    element: <CreateRequestSignature />,
    icon: "icon",
    children: true,
  },
  {
    lable: "Request Signatures",
    path: "/training/request-signatures/approve/:id",
    element: <ApproveRequestPage />,
    icon: "icon",
    children: true,
  },
  {
    lable: "Ratings",
    path: "/training/ratings",
    element: <Ratings />,
    icon: "icon",
  },
  {
    lable: "Achievements",
    path: "/training/achievements",
    element: <Achievement />,
    icon: "icon",
  },
];

export const LogBookRuotes = [
  {
    lable: "Search",
    path: "/",
    element: <Home />,
    icon: search,
  },
  {
    lable: "Flights",
    path: "/logbook/flights",
    element: <Flights />,
    icon: fligths,
  },
  {
    lable: "View Flights",
    path: "/logbook/flights/view_flight/:flightId",
    element: <ViewFlight />,
    icon: "icon",
    children: true,
  },
  {
    lable: "Aircrafts",
    path: "/logbook/aircrafts",
    element: <Aircrafts />,
    icon: aircraft,
  },
  // {
  //   lable: "Airports",
  //   path: "/logbook/airports",
  //   element: <Airport />,
  //   icon: airport,
  // },
  {
    lable: "Backup",
    path: "/logbook/backup",
    element: <Backup />,
    icon: total,
  },
  {
    lable: "Import",
    path: "/logbook/import",
    element: <Import />,
    icon: imports,
  },
];

// export const ReportsRuotes = [
//   {
//     lable: "Report",
//     path: "/report",
//     element: <Report />,
//     icon: "icon",
//   },
// ];

export const AdminRuotes = [
  {
    lable: "Dashboard",
    path: "/admin",
    element: <AdminDashboard />,
    icon: "icon",
  },
  {
    lable: "Users",
    path: "/admin/users",
    element: <Users />,
    icon: "icon",
  },
  {
    lable: "Users",
    path: "/admin/users/user-stats/:id",
    element: <UserStats />,
    icon: "icon",
  },
  {
    lable: "Invite Users",
    path: "/admin/invite-users",
    element: <InviteUsers/>,
    icon: "icon", 
  },
  {
    lable: "Edit User",
    path: "/admin/edit-user/:id",
    element: <EditUser/>,
    icon: "icon", 
  },
  {
    lable: "Groups Form",
    path: "/admin/user-groups-form",
    element: <UserGroupForm />,
    icon: "icon",
  },
  {
    lable: "Groups List",
    path: "/admin/user-groups-list",
    element: <UserGroupList />,
    icon: "icon",
  },
  {
    lable: "Edit Groups",
    path: "/admin/edit-group/:id",
    element: <EditGroup/>,
    icon: "icon", 
  },
  {
    lable: "Flights",
    path: "/admin/flights",
    element: <AdminFlights/>,
    icon: "icon",
  },
];
